import React from "react"

import PackagesMaster from "./PackagesMaster"
import { Color } from "../../../../constants/V2/color"
import BulletItem from "../../../elements/V2/BulletItem"

type Props = {
  backgroundColor: Color
  accentColor: Color
  heading: string
  badgeText?: string
  description: string
  priceValue: string
  pillButtonText: string
  pillButtonUrl: string | YocoCom.YocoLink
  textButtonUrl?: string | YocoCom.YocoLink
  textButtonText?: string
  priceAdornmentText: string
  priceSubscriptText?: string
  priceSuperscriptText: string
  priceDisclaimerText?: string
  priceStrikeSuperscriptText: boolean
  adornmentTextPosition: "left" | "right"
  buyerRecievesList: React.ComponentProps<typeof BulletItem>[]
  mobileGridOrder?: number
  trackingEvent?: string
  trackingEventKey?: string
  trackingEventValue?: string
}

const Compare = (props: Props) => {
  return <PackagesMaster {...props} />
}

export default Compare
